import { render, staticRenderFns } from "./PlacementsEndComponentOverall.vue?vue&type=template&id=57ea61e0&"
import script from "./PlacementsEndComponentOverall.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports